<template>
    <form method="post" :action="formAction">
        <input
            type="hidden"
            name="_token"
            :value="csrfToken"
        >
        <input
            type="hidden"
            name="_method"
            :value="formMethod"
        >

        <expanding-textarea-input
            :id="textAreaId"
            name="text"
            :value="text"
            placeholder="Skriv en kommentar"
            :required="true"
        >
            <button type="submit" class="btn btn-sm is-primary">{{ buttonText }}</button>
        </expanding-textarea-input>
    </form>
</template>

<script>
    import ExpandingTextareaInput from '@/Front/Components/ExpandingTextareaInput';

    export default {
        components: { ExpandingTextareaInput },

        props: {
            productId: {
                type: Number,
                required: true,
            },
            comment: {
                type: Object,
                default: null,
            },
            initialValue: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                text: this.initialValue ? this.initialValue : this.comment?.text,
            };
        },

        computed: {
            formMethod() {
                return this.comment ? 'PATCH' : 'POST';
            },
            formAction() {
                if (this.comment) {
                    return this.route(
                        'front.products.comments.update',
                        [this.productId, this.comment],
                    );
                }

                return this.route('front.products.comments.store', this.productId);
            },
            csrfToken() {
                return window.App.csrfToken;
            },
            textAreaId() {
                if (this.comment) {
                    return `comment-textarea-${this.comment.id}`;
                }

                return 'comment-textarea-new';
            },
            buttonText() {
                return this.comment ? 'Ändra' : 'Publicera';
            },
        },
    };
</script>
